import { render, staticRenderFns } from "./notFoundExams.partial.vue?vue&type=template&id=1b229c20"
import script from "./notFoundExams.partial.vue?vue&type=script&lang=js"
export * from "./notFoundExams.partial.vue?vue&type=script&lang=js"
import style0 from "./notFoundExams.partial.vue?vue&type=style&index=0&id=1b229c20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports